import React, { useState, useEffect } from "react";
import { db } from "@/api/db";
import { Award, Download } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function Certificates() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const u = await db.auth.me();
    const certs = await db.entities.Certificate.filter({ user_email: u.email }, "-issued_at");
    setCertificates(certs);
    setLoading(false);
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Meus Certificados</h1>
        <p className="text-gray-500 mt-1">Conquistas validadas pela Portüs Academy.</p>
      </div>

      {certificates.length === 0 ? (
        <Card className="border-0 shadow-sm">
          <CardContent className="p-16 text-center">
            <Award className="w-12 h-12 text-gray-200 mx-auto mb-4" />
            <p className="font-medium text-gray-600">Nenhum certificado ainda</p>
            <p className="text-gray-400 text-sm mt-1">Complete todas as aulas de um nível e passe na prova final para obter seu certificado.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {certificates.map(cert => (
            <Card key={cert.id} className="border-0 shadow-sm overflow-hidden">
              <div className="h-1.5 bg-gradient-to-r from-emerald-400 to-emerald-600" />
              <CardContent className="p-5">
                <div className="flex items-start gap-3">
                  <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Award className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gray-900 truncate">{cert.track_title || "Trilha"}</p>
                    <p className="text-gray-500 text-sm">{cert.level_title || "Nível"}</p>
                    <p className="text-gray-400 text-xs mt-1">
                      Emitido em {cert.issued_at ? new Date(cert.issued_at).toLocaleDateString("pt-BR") : "–"}
                    </p>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                  <Badge variant="outline" className="text-xs font-mono text-gray-500">
                    {cert.certificate_code}
                  </Badge>
                  <Button size="sm" variant="ghost" className="h-7 text-xs text-emerald-600 gap-1.5 hover:bg-emerald-50">
                    <Download className="w-3 h-3" /> Baixar
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}